"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import BenefitsComponent from "./components/benefits";
import Implementation from "./components/implementation";

const PrivateK8ClustersPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PrivateCloudTabs />
        <Intro />
        <BenefitsComponent />
        <Implementation />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default PrivateK8ClustersPage;
